/**
 * Supplier Filters Context
 *
 * Manages filter state for the suppliers list using the generic filters factory.
 */

import {
  createFiltersContext,
  addStringFilter,
} from "@/shared/contexts/FiltersContextFactory";
import { supplierUrlSync } from "../configs/urlSync";

// ----- FILTER STATE TYPE ----- //
type SupplierFiltersState = { search: string };

// ----- INITIAL STATE ----- //
const INITIAL_STATE: SupplierFiltersState = { search: "" };

// ----- QUERY STRING BUILDER ----- //
const buildQueryString = (state: SupplierFiltersState): string => {
  const params = new URLSearchParams();

  addStringFilter(params, "q[smart_search]", state.search);

  return params.toString();
};

// ----- CREATE CONTEXT ----- //
const { Provider, useFilters, Context } = createFiltersContext({
  name: "Supplier",
  initialState: INITIAL_STATE,
  buildQueryString,
  urlSync: supplierUrlSync,
});

// ----- EXPORTS ----- //
export const SupplierFiltersProvider = Provider;
export const useSupplierFilters = useFilters;
export const SupplierFiltersContext = Context;

// Re-export type for consumers
export type { SupplierFiltersState };
